import { AutogenModelLaneHistory, AutogenRowLaneHistory } from "./autogen/AutogenModelLaneHistory";

export class ModelLaneHistory extends AutogenModelLaneHistory<RowLaneHistory> {
    constructor() {
        super(RowLaneHistory);
    }
}

export class RowLaneHistory extends AutogenRowLaneHistory {
}